import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const visitorsAPI = {
  /** GET **/
  // 내방신청 현황 API
  async getVisitorsStatusAPI(date: string, businessPlaceId: string, name: string, securityCardNumber: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.visitorsController.getVisitorsStatus(date, businessPlaceId, name, securityCardNumber), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      return response.data;
    } catch (error) {
      // console.error('getVisitorsStatusAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },

  //출입보안카드 내역 조회 API
  async getVisitorIdSecurityCardNumberHistoryAPI(visitorId: number, securityCardNumber: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(`${END_POINT.visitorsController.getVisitorIdSecurityCardNumberHistory(visitorId, securityCardNumber)}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      return response.data;
    } catch (error) {
      // console.error('getVisitorIdSecurityCardNumberHistoryAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },

  /** POST **/
  //출입보안카드 파손 API
  postVisitorIdSecurityCardNumberDamageAPI: async (visitorId: number, securityCardNumber: string, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post<any>(END_POINT.visitorsController.postVisitorIdSecurityCardNumberDamage(visitorId, securityCardNumber), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });
      return response;
    } catch (error) {
      // console.error('postVisitorIdSecurityCardNumberDamageAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  //출입보안카드 지급 API
  postVisitorIdSecurityCardNumberIssueAPI: async (visitorId: number, securityCardNumber: string, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post<any>(END_POINT.visitorsController.postVisitorIdSecurityCardNumberIssue(visitorId, securityCardNumber), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });
      return response;
    } catch (error) {
      // console.error('postVisitorIdSecurityCardNumberIssueAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  //출입보안카드 분실 API
  postVisitorIdSecurityCardNumberLoseAPI: async (visitorId: number, securityCardNumber: string, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post<any>(END_POINT.visitorsController.postVisitorIdSecurityCardNumberLose(visitorId, securityCardNumber), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });
      return response;
    } catch (error) {
      // console.error('postVisitorIdSecurityCardNumberLoseAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  //출입보안카드 분실 취소 API
  postVisitorIdSecurityCardNumberLoseCancelAPI: async (visitorId: number, securityCardNumber: string, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      // console.log('출입보안카드 분실취소 : postVisitorIdSecurityCardNumberLoseCancelAPI id data: ', data);
      const response = await httpService.post<any>(
        END_POINT.visitorsController.postVisitorIdSecurityCardNumberLoseCancel(visitorId, securityCardNumber),
        data,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
          }
        }
      );
      // console.log('출입보안카드 분실취소 : postVisitorIdSecurityCardNumberLoseCancelAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('postVisitorIdSecurityCardNumberLoseCancelAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  //출입보안카드 파손 취소 API
  postVisitorIdSecurityCardNumberDamageCancelAPI: async (visitorId: number, securityCardNumber: string, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      // console.log('출입보안카드 분실취소 : postVisitorIdSecurityCardNumberLoseCancelAPI id data: ', data);
      const response = await httpService.post<any>(
        END_POINT.visitorsController.postVisitorIdSecurityCardNumberDamageCancel(visitorId, securityCardNumber),
        data,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
          }
        }
      );
      // console.log('출입보안카드 분실취소 : postVisitorIdSecurityCardNumberLoseCancelAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('postVisitorIdSecurityCardNumberLoseCancelAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  //출입보안카드 회수 API
  postVisitorIdSecurityCardNumberReturnAPI: async (visitorId: number, securityCardNumber: string, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post<any>(END_POINT.visitorsController.postVisitorIdSecurityCardNumberReturn(visitorId, securityCardNumber), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });
      return response;
    } catch (error) {
      // console.error('postVisitorIdSecurityCardNumberReturnAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  }
};

export const {
  getVisitorsStatusAPI,
  getVisitorIdSecurityCardNumberHistoryAPI,
  postVisitorIdSecurityCardNumberDamageAPI,
  postVisitorIdSecurityCardNumberIssueAPI,
  postVisitorIdSecurityCardNumberLoseAPI,
  postVisitorIdSecurityCardNumberLoseCancelAPI,
  postVisitorIdSecurityCardNumberDamageCancelAPI,
  postVisitorIdSecurityCardNumberReturnAPI
} = visitorsAPI;
